import { Box, Button, Typography } from "@mui/material";

export default function ActivityDeleteButton({ selectedCount, onClick, disabled }) {
  return (
    <Box>
      <Typography variant="h6" mt={2}>Borrar actividad/es</Typography>
      <Button
        variant="contained"
        color="error"
        onClick={onClick}
        disabled={disabled}
        fullWidth
        sx={{
          mt: 2,
          ml: "auto",
          fontSize: { md: "16px", sm: "10px" },
        }}
      >
        Eliminar: {selectedCount}
      </Button>
    </Box>
  );
}
